import { graphql } from "~/gql";

export const NOTIFICATION_RULE_QUERY = graphql(/* GraphQL */ `
  query NotificationRules {
    notificationRules {
      ...NotificationRuleParts
    }
  }
`);
